import type SecurityService from "services/securityService";

export function allowToPair(securityService: SecurityService): boolean {
  return (
    (securityService.allowTo("callcenter.finance", "write") || securityService.allowTo("finance", "write")) &&
    (securityService.allowTo("finance.factualauditing", "write") ||
      securityService.allowTo("finance.commandoperating", "write") ||
      securityService.allowTo("finance.chiefaccounting", "write") ||
      securityService.allowTo("callcenter.chargeauditing", "write"))
  );
}

// eslint-disable-next-line sonarjs/no-identical-functions
export function allowToRefund(securityService: SecurityService): boolean {
  return (
    (securityService.allowTo("callcenter.finance", "write") || securityService.allowTo("finance", "write")) &&
    (securityService.allowTo("finance.factualauditing", "write") ||
      securityService.allowTo("finance.commandoperating", "write") ||
      securityService.allowTo("finance.chiefaccounting", "write") ||
      securityService.allowTo("callcenter.chargeauditing", "write"))
  );
}
